import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CompassOutlined } from '@ant-design/icons';
import { EmptyState } from './pageKit';

import './pages.css';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="pg-404">
      <div className="pg-404__code">404</div>
      <EmptyState
        muted
        icon={<CompassOutlined />}
        title="这个地址没有对应的页面"
        // 404 最常见的成因是链接里带了已被删除的 ID，直说比「页面不存在」有用
        description="可能是链接里的 ID 已被删除，或者路径拼错了。回到概览重新进入吧。"
        action={
          <Button type="primary" onClick={() => navigate('/dashboard')}>
            回到概览
          </Button>
        }
      />
    </div>
  );
}
